import { motion } from "framer-motion";
import { ArrowUpRight, Phone } from "lucide-react";
import { BUSINESS } from "@/data/content";

export default function Ordering() {
  return (
    <section id="order" className="bg-sand py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-terracotta text-xs uppercase tracking-[0.25em] mb-5">Order Online</p>
          <h2 className="font-serif-display text-5xl md:text-6xl text-ink leading-[0.95]">Hot & ready, delivered your way.</h2>
          <p className="text-ink/65 mt-5">Pick your platform and we'll fire it up. Pickup? Give us a call and skip the line.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { name: "DoorDash", href: BUSINESS.doordash, test: "order-doordash", sub: "Delivery in ~35 min" },
            { name: "Uber Eats", href: BUSINESS.ubereats, test: "order-ubereats", sub: "Delivery in ~30 min" },
            { name: "Grubhub", href: BUSINESS.grubhub, test: "order-grubhub", sub: "Delivery in ~35 min" },
          ].map((p, i) => (
            <motion.a key={p.name} href={p.href} target="_blank" rel="noreferrer" data-testid={p.test}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.06 }}
              className="group bg-charcoal text-cream rounded-lg p-8 flex flex-col justify-between h-52 hover:bg-terracotta transition-colors duration-300">
              <ArrowUpRight className="self-end group-hover:rotate-45 transition-transform duration-300" />
              <div>
                <h3 className="font-serif-display text-3xl">{p.name}</h3>
                <p className="text-cream/60 text-sm mt-1">{p.sub}</p>
              </div>
            </motion.a>
          ))}
          <motion.a href={BUSINESS.phoneHref} data-testid="order-call"
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.18 }}
            className="group border-2 border-ink/20 text-ink rounded-lg p-8 flex flex-col justify-between h-52 hover:border-terracotta hover:bg-cream transition-colors duration-300">
            <Phone className="self-end text-terracotta" />
            <div>
              <h3 className="font-serif-display text-3xl">Call for Pickup</h3>
              <p className="text-ink/55 text-sm mt-1">{BUSINESS.phone}</p>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
